/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontLayout_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontRefetch_viewer$ref: FragmentReference;
export type StorefrontRefetch_viewer = {|
  +$fragmentRefs: StorefrontLayout_viewer$ref,
  +$refType: StorefrontRefetch_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontRefetch_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontLayout_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0af1ab8edca5d9d607f872d248fb31a4';
module.exports = node;
